import { URL } from "../../api/Api";
import { HARIZON } from "../Action";
import { catchError, GET, getToken } from "../axios/Axios";

export const HarizonAnalytics = (params) => {
  return async (dispatch) => {
    try {
      const response = await GET(`${URL}/usage/report`, params);
      dispatch({ type: HARIZON.harizonAnalytics, data: response.data });
      return response.data;
    } catch (error) {
      throw catchError(error);
    }
  };
};

export const UserName = async (id) => {
  try {
    const response = await GET(`${URL}/customers/users/${id}/`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const GetAllCountryLocation = async () => {
  try {
    const response = await GET(`https://ipwho.is`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};

export const NotificationBanner = async (id) => {
  try {
    const response = await GET(`${URL}/adminpanel/notification/banner`, {});
    return response;
  } catch (error) {
    throw catchError(error);
  }
};
